/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EnabledPayer } from './EnabledPayer';
import {
    EnabledPayerFromJSON,
    EnabledPayerFromJSONTyped,
    EnabledPayerToJSON,
    EnabledPayerToJSONTyped,
} from './EnabledPayer';

/**
 * 
 * @export
 * @interface GetEnabledPayers200Response
 */
export interface GetEnabledPayers200Response {
    /**
     * 
     */
    data?: Array<EnabledPayer>;
}

/**
 * Check if a given object implements the GetEnabledPayers200Response interface.
 */
export function instanceOfGetEnabledPayers200Response(value: object): value is GetEnabledPayers200Response {
    return true;
}

export function GetEnabledPayers200ResponseFromJSON(json: any): GetEnabledPayers200Response {
    return GetEnabledPayers200ResponseFromJSONTyped(json, false);
}

export function GetEnabledPayers200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetEnabledPayers200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(EnabledPayerFromJSON)),
    };
}

export function GetEnabledPayers200ResponseToJSON(json: any): GetEnabledPayers200Response {
    return GetEnabledPayers200ResponseToJSONTyped(json, false);
}

export function GetEnabledPayers200ResponseToJSONTyped(value?: GetEnabledPayers200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(EnabledPayerToJSON)),
    };
}

